export default __webpack_public_path__ + "static/feature-banner-clothes-shopping-online-07dfd739c7d654a856692e6ee9c9ab63.jpg";